import React from 'react'
import { Plus, Sparkles } from 'lucide-react'
import Button from '../../../../components/ui/button'
import { useNavigate } from 'react-router-dom'

export const EmptyDraftState: React.FC<{ onAddFirstLine: () => void }> = ({ onAddFirstLine }) => {
  const navigate = useNavigate()

  const handleGenerateWithAI = () => {
    // Navigate to dashboard where the user can use PodcastInput
    navigate('/')
  }

  return (
    <div className="p-8 flex items-center justify-center min-h-[400px]">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-brand-50 flex items-center justify-center">
          <Sparkles className="w-7 h-7 text-brand-600" />
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">Generate your podcast with AI</h3>
        <p className="text-sm text-foreground/60 mb-6">
          Turn any link, idea, or document into a podcast in minutes. Our AI will create the dialogue for you.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleGenerateWithAI} className="gap-2">
            <Sparkles className="h-4 w-4" />
            Generate with AI
          </Button>
          <Button onClick={onAddFirstLine} variant="ghost" className="gap-2">
            <Plus className="h-4 w-4" />
            Add first line
          </Button>
        </div>
      </div>
    </div>
  )
}
